import { FC, ReactNode } from 'react';
import { StyledList } from './UnorderList.styles';

export type LocalProps = { children?: ReactNode };
const UnorderList: FC<LocalProps> = ({ children }) => {
  return <StyledList>{children}</StyledList>;
};

export default UnorderList;
